"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricsToolbar = void 0;
var react_1 = __importDefault(require("react"));
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
/**
 * Toolbar for the category panel. Switches between the action row
 * (New Group) and the inline name-edit form. Rename/Delete actions live
 * on each category card.
 */
exports.MetricsToolbar = function (_a) {
    var edit = _a.edit, onStartAdd = _a.onStartAdd;
    return (react_1.default.createElement("div", { className: "ws-metrics-category-toolbar" },
        react_1.default.createElement(office_ui_fabric_react_1.TooltipHost, { content: "Add a new metric group", calloutProps: { gapSpace: 4 } },
            react_1.default.createElement(office_ui_fabric_react_1.IconButton, { iconProps: { iconName: 'Add' }, title: "Add a new metric group", ariaLabel: "Add a new metric group", className: "ws-metrics-category-action-btn", disabled: !!edit, onClick: onStartAdd }))));
};
